<ng-template #modal let-modal class="modal-dialog-centered">
    <div class="modal-header">
        <h4 class="modal-title text-center w-100" id="modalLabel">{{'BOARD.COLUMN' | translate }}</h4>
        <button type="button" class="btn-close" tabindex="-1" aria-label="Close" (click)="closeModal()">
        </button>
    </div>
    <div class="modal-body p-1">
        <form [formGroup]="columnForm" class="form p-2">
            <div class="row">
                <div class="col col-6 col-xs-6 col-md-6 col-lg-6">
                    <div class="form-check  form-switch mt-1" style="padding-left: 21px !important">
                        <input type="checkbox" class="form-check-input check-padding" 
                            formControlName="resolvedTasks">
                        <label style="margin-left: 0" class="form-check-label text-primary">{{'SETTINGS.COLUMN.RESOLVEDTASK'
                            |translate}}</label>
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col col-12 col-xs-12 col-md-12 col-lg-12">
                    <label class="form-label">{{ 'BOARD.FORM.NAME' | translate }} <span
                            class="text-error">*</span></label>
                    <input type="text" class="form-control" formControlName="name" required
                        [ngClass]="{ 'is-invalid': submitted && formColumn.name.invalid}">
                    <div class="form-validation" *ngIf="submitted && formColumn.name.errors?.required">
                        {{ 'BOARD.FORM.NAMEERROR' | translate }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col col-12 col-xs-12 col-md-12 col-lg-12">
                    <label class="form-label">{{ 'BOARD.FORM.COLOR' | translate }} <span
                            class="text-error">*</span></label>
                    <input class="form-control color-input" id="example-color" type="color" required formControlName="color"
                        [ngClass]="{ 'is-invalid': submitted && formColumn.color.invalid}">
                    <div class="form-validation" *ngIf="submitted && formColumn.color.errors?.required">
                        {{ 'BOARD.FORM.COLORERROR' | translate }}
                    </div>
                </div>
            </div>
        </form>

    </div>

    <div class="mt-2 mb-2 d-flex justify-content-center">

        <button *ngIf="columnForm.value.id ==0" class="btn btn-primary waves-effect waves-light btnSaveBottom btnSaveMinW2" [disabled]="loading"
            (click)="save()">
            {{'BOARD.FORM.ADDCOLUMN'| translate}}
        </button>
        <button *ngIf="columnForm.value.id !=0 && columnForm.value.id !=null" class="btn btn-primary waves-effect waves-light btnSaveBottom btnSaveMinW2" [disabled]="loading"
            (click)="save()">
            {{'BOARD.FORM.EDITCOLUMN'| translate}}
        </button>
    </div>
</ng-template>